
const weixinLoginUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize';
const jsapi_appId = 'wxd5874c16f8a2bdd5';

export default {
  appId: 'wx92cd264407168a35',
  appSecret: '35cd9f83137cc4efe6e9d1392cdc65b6',

  jsapiPayStatus: 1003,
  jsApiLoginStatus: 1002,

  jsapi_weixinLoginAutorize(redirect_url) {
    this.jsapi_weixinAutorize(redirect_url, 'snsapi_userinfo', this.jsApiLoginStatus);
  },

  jsapi_weixinAutorize(redirect_url, scope, state) {
    let url = weixinLoginUrl;
    let redirectUri = redirect_url;
    let index = redirectUri.indexOf('www.');
    if (index != -1) {
      let ll = redirectUri.split('www.');
      let newStr = '';
      for (let i = 0; i < ll.length; i++) {
        newStr += ll[i];
      }
      redirectUri = newStr
    }
    redirectUri = encodeURI(redirectUri);
    let appId = jsapi_appId;

    url += '?' + 'appid=' + appId;
    url += '&' + 'redirect_uri=' + redirectUri;
    url += '&' + 'response_type=code';
    url += '&' + 'scope=' + scope;
    url += '&' + 'state=' + state;
    url += '#wechat_redirect';
    console.log(url);
    window.location.href = url;
  },

  jsapi_sendPayRequest(params, success, failure) {
    wx.chooseWXPay({
      timestamp: params.timeStamp,   //时间戳，自1970年以来的秒数
      nonceStr: params.nonceStr,     //随机串
      package: params.sPackage,
      signType: 'MD5',     //微信签名方式：
      paySign: params.paySign,      //微信签名
      success: function (res) {
        success(res);
        },
      fail: function (data) {
        failure(data);
      }
    });
  },

  jsapi_payAutorize(redirect_url) {
    this.jsapi_weixinAutorize(redirect_url, 'snsapi_base', this.jsapiPayStatus);
  },
};



// WEBPACK FOOTER //
// ./src/js/weixin.config.js